module.exports = __webpack_public_path__ + "assets/e6d0818fc443f1d7c5b32beaaffb711c.png";